class FourDScriptLoaderHelper {
    constructor() {
        this.statuses = {
            Loaded: 'Loaded',
            Error: 'Error',
            InProgress: 'InProgress'
        };
        this.scripts = new Map();
    }
    requestScriptLoaded(scriptPath, successCallback, errorCallback, scriptName) {
        if (!scriptPath) return;
        if (!scriptName) scriptName = scriptPath;
        // Check status of requested script
        let addHandlersRequired = false;
        let loadRequired = false;
        let currentScript = this.scripts.get(scriptName);
        if (currentScript) {
            // Script has already been requested
            if (currentScript.status == this.statuses.InProgress) {
                // In progress, add handlers to list
                addHandlersRequired = true;
            } else if (currentScript.status == this.statuses.Error) {
                // Error loading, try again
                addHandlersRequired = true;
                loadRequired = true;
            } else if (currentScript.status == this.statuses.Loaded) {
                // Already loaded successfully
                if (typeof (successCallback) == 'function') {
                    try {
                        successCallback(scriptName, null);
                    }
                    catch (err) {
                        if (typeof (fourdLogError) == 'function') {
                            fourdLogError(`Error '${err}' calling successCallback for '${scriptName}' in requestScriptLoaded`, err);
                        }
                    }
                }
            }
        }
        else {
            // Script has not yet been requested, add to list and request
            // Add to list immediately
            this.scripts.set(scriptName, { status: this.statuses.InProgress, tag: null, successCallbacks: [], errorCallbacks: [], scriptPath: scriptPath });
            currentScript = this.scripts.get(scriptName);
            addHandlersRequired = true;
            loadRequired = true;
        }

        if (addHandlersRequired) {
            if (typeof (successCallback) !== 'undefined') {
                currentScript.successCallbacks.push(successCallback);
            }
            if (typeof (errorCallback) !== 'undefined') {
                currentScript.errorCallbacks.push(errorCallback);
            }
        }

        if (loadRequired) {
            if (currentScript.tag) {
                // Remove existing tag
                currentScript.tag.remove();
            }

            // Create new tag
            let newTag = document.createElement("script");
            // Set URL
            newTag.src = scriptPath;
            // Add event handlers
            newTag.onload = (event) => {
                this.handleScriptLoadSuccess(scriptName, event);
            };
            newTag.onerror = (event) => {
                this.handleScriptLoadError(scriptName, event);
            };
            // Add tag object to script list
            currentScript.tag = newTag;
            // Insert new tag to document body
            document.body.appendChild(newTag);
        }

    }
    handleScriptLoadSuccess(scriptName, event) {
        // Script has successfully loaded
        let currentScript = this.scripts.get(scriptName);
        if (currentScript) {
            // Set status
            currentScript.status = this.statuses.Loaded;
            if (currentScript.successCallbacks && currentScript.successCallbacks.length) {
                // Call callbacks
                currentScript.successCallbacks.forEach((successCallback) => {
                    try {
                        if (typeof (successCallback) == 'function') {
                            successCallback(scriptName, event);
                        }
                    }
                    catch (err) {
                        if (typeof (fourdLogError) == 'function') {
                            fourdLogError(`Error '${err}' calling successCallback for '${scriptName}' in handleScriptLoadSuccess`, err);
                        }
                    }
                });
                // Clear callback list
                currentScript.successCallbacks = [];
            }
        }
    }
    handleScriptLoadError(scriptName, event) {
        // Error loading script
        let currentScript = this.scripts.get(scriptName);
        if (currentScript) {
            // Set status
            currentScript.status = this.statuses.Error;
            if (currentScript.errorCallbacks && currentScript.errorCallbacks.length) {
                // Call callbacks
                currentScript.errorCallbacks.forEach((errorCallback) => {
                    try {
                        if (typeof (errorCallback) == 'function') {
                            errorCallback(scriptName, event);
                        }
                    }
                    catch (err) {
                        if (typeof (fourdLogError) == 'function') {
                            fourdLogError(`Error '${err}' calling errorCallback for '${scriptName}' in handleScriptLoadError`, err);
                        }
                    }
                });
                // Clear callback list
                currentScript.errorCallbacks = [];
            }
        }
        if (typeof (fourdHandleScriptLoadError) == 'function') {
            fourdHandleScriptLoadError(event, false);
        }
    }

};

const FourDScriptLoader = new FourDScriptLoaderHelper();